var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.marketPercentage > 0)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.marketPercentage)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }